module.exports = __webpack_public_path__ + "static/media/logo-white-green.632606a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-white-green.png
// module id = 1260
// module chunks = 270